export const marital = [
  { value: '', text: 'Select' },
  { value: 'SI', text: 'Single' },
  { value: 'MA', text: 'Married' },
  { value: 'WI', text: 'Widowed' },
  { value: 'SA', text: 'Separated' },
  { value: 'DI', text: 'Divorced' },
  { value: 'DP', text: 'Domestic Partner' }

]

export const MARITAL = marital.map(item => {
  item.group = 'marital'
  return item
})
